import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import * as colors from '~/constants/colors';
import arrowRight from '~/images/icons/arrowright.svg';

import { TYPOGRAPHY } from '~/constants/typography';

const heroImage = `${process.env.GATSBY_IMAGES}home/hero-image.png`;
export default makeStyles((theme: Theme) =>
    createStyles({
        hero: {
            minHeight: 656,
            backgroundImage: `url(${heroImage})`,
            backgroundPosition: 'right bottom',
            backgroundRepeat: 'no-repeat',
            overflow: 'hidden',
            backgroundSize: 'contain',
            [theme.breakpoints.down('xs')]: {
                minHeight: 520,
                backgroundSize: '115%',
            },
            [theme.breakpoints.up('lg')]: {
                backgroundSize: '100%',
                minHeight: 720,
            },
        },
        heroTitle: {
            color: theme.palette.primary.dark,
            [theme.breakpoints.between('md', 'lg')]: {
                fontSize: 50,
            },
            [theme.breakpoints.down('sm')]: {
                fontSize: 50,
            },
            [theme.breakpoints.down('xs')]: {
                fontSize: 50,
                marginBottom: theme.spacing(1),
            },
        },
        heroSubtitle: {
            color: colors.GREY_COLOR.Grey1,
            width: '60%',
            [theme.breakpoints.between('md', 'lg')]: {
                fontSize: 16,
                width: '100%',
            },
            [theme.breakpoints.down('sm')]: {
                fontSize: 16,
                width: '70%',
            },
            [theme.breakpoints.down('xs')]: {
                fontSize: 16,
                width: '95%',
                lineHeight: 1.75,
                letterSpacing: 0.25,
            },
        },
        joinUs: {
            background: colors.GREY_COLOR.Grey6,
            boxShadow: `0 2px 4px 0 rgba(0, 0, 0, 0.16)`,
            height: '100%',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            padding: theme.spacing(0, 2),
            boxSizing: 'border-box',
        },
        joinUsGridItem: {
            [theme.breakpoints.down('sm')]: {
                display: 'none',
            },
        },
        advantages: {},
        advantagesBlock: {
            background: colors.GREY_COLOR.Grey6,
            paddingTop: theme.spacing(5),
            [theme.breakpoints.down('xs')]: {
                paddingBottom: theme.spacing(5),
                paddingTop: theme.spacing(2),
            },
        },
        mobileJoinUs: {
            margin: '96px auto',
            width: '50%',
            display: 'none',
            boxSizing: 'border-box',
            boxShadow: `0 2px 4px 0 rgba(0, 0, 0, 0.08)`,
            background: colors.GREY_COLOR.Grey6,
            padding: '48px 36px',
            [theme.breakpoints.down('sm')]: {
                display: 'flex',
            },
            [theme.breakpoints.down('xs')]: {
                display: 'flex',
                width: 'auto',
                boxSizing: 'border-box',
                marginLeft: theme.spacing(2),
                marginRight: theme.spacing(2),
                padding: theme.spacing(6, 3),
            },
        },
        section: {
            paddingTop: 32,
            paddingBottom: 96,
            position: 'relative',
        },
        afterMobileJoinUs: {
            [theme.breakpoints.up('sm')]: {
                paddingTop: 96,
            },
        },
        sectionTitle: {
            color: colors.GREY_COLOR.Grey2,
        },
        centered: {
            display: 'flex',
            justifyContent: 'center',
            textAlign: 'center',
        },
        h3Title: {
            color: theme.palette.primary.dark,
            padding: theme.spacing(2, 0),
            [theme.breakpoints.down('xs')]: {
                ...TYPOGRAPHY.h4,
            },
        },
        text: {
            color: colors.GREY_COLOR.Grey1,
        },
        video: {
            marginTop: theme.spacing(8),
            [theme.breakpoints.down('sm')]: {
                width: 'calc(100% + 80px)',
                marginLeft: theme.spacing(-5),
                marginRight: theme.spacing(-5),
            },
            [theme.breakpoints.down('xs')]: {
                width: 'calc(100% + 32px)',
                marginLeft: theme.spacing(-2),
                marginRight: theme.spacing(-2),
                height: '216px',
            },
        },
        contentSubtitle: {
            color: colors.GREY_COLOR.Grey1,
            margin: theme.spacing(2, 0),
        },
        grayWrapper: {
            background: colors.GREY_COLOR.Grey6,
        },
        subtitle: {
            color: colors.GREY_COLOR.Grey1,
            marginBottom: theme.spacing(5),
        },
        caseCard: {
            borderRadius: 4,
            boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.08)',
            background: colors.WHITE_COLOR,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        caseTitle: {
            color: colors.GREY_COLOR.Grey1,
            marginBottom: 14,
        },
        caseIcon: {
            height: 120,
            width: '80%',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '50%',
        },
        caseItem: {
            '&&': {
                [theme.breakpoints.down('xs')]: {
                    padding: theme.spacing(0.5, 0),
                    '&:nth-child(odd)': {
                        paddingRight: 2.5,
                    },
                    '&:nth-child(even)': {
                        paddingLeft: 2.5,
                    },
                },
            },
        },
        casesGrid: {
            [theme.breakpoints.down('xs')]: {
                width: '100%',
                margin: 0,
            },
        },
        resources: {
            marginTop: theme.spacing(3),
            [theme.breakpoints.down('md')]: {
                width: '100%',
                margin: 0,
                marginTop: theme.spacing(3),
            },
            [theme.breakpoints.down('sm')]: {
                width: `calc(100% + ${theme.spacing(4)}px)`,
                margin: theme.spacing(-2),
                marginTop: theme.spacing(3),
            },
        },
        resourceItem: {
            '&&': {
                [theme.breakpoints.down('md')]: {
                    padding: theme.spacing(1.5, 0),
                    '&:nth-child(odd)': {
                        paddingRight: theme.spacing(1.5),
                    },
                    '&:nth-child(even)': {
                        paddingLeft: theme.spacing(1.5),
                    },
                },
                [theme.breakpoints.down('sm')]: {
                    padding: `${theme.spacing(1.5, 2)} !important`,
                    '&:nth-child(odd)': {
                        paddingRight: 0,
                    },
                    '&:nth-child(even)': {
                        paddingLeft: 0,
                    },
                },
                [theme.breakpoints.down('xs')]: {
                    padding: `${theme.spacing(1.5, 2)} !important`,
                    '&:nth-child(odd)': {
                        paddingRight: 0,
                    },
                    '&:nth-child(even)': {
                        paddingLeft: 0,
                    },
                },
            },
        },
        resource: {
            borderRadius: 4,
            position: 'relative',
            background: colors.WHITE_COLOR,
            display: 'flex',
            alignItems: 'center',
            boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.08)',
            cursor: 'pointer',
            transition: '0.5s',
            '&:hover': {
                boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.3)',
            },
            '&::before': {
                width: 24,
                height: 24,
                display: 'block',
                content: "''",
                backgroundImage: `url(${arrowRight})`,
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                position: 'absolute',
                right: theme.spacing(3),
                bottom: theme.spacing(2),
            },
            [theme.breakpoints.down('xs')]: {
                flexDirection: 'column',
            },
        },
        resourceImage: {
            width: 160,
            height: 160,
            margin: theme.spacing(2, 4),
            [theme.breakpoints.down('md')]: {
                width: 120,
                height: 120,
                margin: theme.spacing(1.5, 2),
                marginRight: theme.spacing(3),
            },
            [theme.breakpoints.down('sm')]: {
                width: 144,
                height: 144,
                margin: theme.spacing(1),
                marginRight: theme.spacing(3),
            },
            [theme.breakpoints.down('xs')]: {
                width: 148,
                height: 148,
                marginRight: 0,
            },
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            marginRight: theme.spacing(4),
        },
        resourceTitle: {
            color: colors.GREY_COLOR.Grey1,
            [theme.breakpoints.down('md')]: {
                ...TYPOGRAPHY.body1,
                width: '75%',
            },
            [theme.breakpoints.down('xs')]: {
                width: '80%',
                alignSelf: 'flex-start',
                display: 'block',
                boxSizing: 'border-box',
                padding: theme.spacing(2),
            },
        },
        gray1Text: {
            color: colors.GREY_COLOR.Grey1,
        },
        dentists: {
            marginTop: theme.spacing(3),
            [theme.breakpoints.down('sm')]: {
                maxWidth: 512,
                margin: '0 auto',
                marginTop: theme.spacing(3),
            },
            [theme.breakpoints.down('xs')]: {
                maxWidth: 'initial',
                margin: theme.spacing(-2),
                marginTop: theme.spacing(3),
            },
        },
        dentistItem: {
            '&&': {
                [theme.breakpoints.down('md')]: {
                    padding: theme.spacing(1.5, 2),
                },
            },
        },
        dentist: {
            borderRadius: 4,
            overflow: 'hidden',
            boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.08)',
        },
        dentistHeader: {
            display: 'flex',
            alignItems: 'center',
            background: colors.GREY_COLOR.Grey5,
            padding: theme.spacing(2),
            boxSizing: 'border-box',
        },
        dentistName: {},
        dentistImage: {
            height: 96,
            width: 96,
            [theme.breakpoints.down('xs')]: {
                height: 80,
                width: 80,
            },
            backgroundSize: 'contain',
            marginRight: theme.spacing(2),
        },
        dentistFullname: {
            fontSize: 16,
        },
        dentistBody: {
            background: colors.WHITE_COLOR,
            padding: theme.spacing(3),
            ...TYPOGRAPHY.body1,
            color: '#393c3f',
            boxSizing: 'border-box',
            [theme.breakpoints.down('md')]: {
                padding: theme.spacing(2),
            },
            [theme.breakpoints.down('sm')]: {
                padding: theme.spacing(3),
            },
            [theme.breakpoints.down('xs')]: {
                padding: theme.spacing(2),
            },
        },
        centeredBlueTitle: {
            color: theme.palette.primary.dark,
            textAlign: 'center',
            marginTop: theme.spacing(5),
        },
        centeredDescription: {
            color: colors.GREY_COLOR.Grey1,
            textAlign: 'center',
            marginTop: theme.spacing(1),
        },
        slider: {
            marginTop: theme.spacing(7),
            [theme.breakpoints.down('xs')]: {
                marginTop: theme.spacing(4),
            },
        },
    })
);
